import { isFunction as s } from "./other.es.js";
const l = (t, n) => {
  const r = {};
  if (!t) return r;
  for (let o = 0; o < t.length; o++) {
    const e = t[o];
    n ? n(r, e) : r[String(e)] = e;
  }
  return r;
}, a = (t, n) => t ? (Array.isArray(n) ? n : [n]).every((o) => t.includes(o)) : !1, A = (t, n) => t ? (Array.isArray(n) ? n : [n]).some((o) => t.includes(o)) : !1, d = (t, n, r = ", ") => {
  if (!t) return "";
  const o = s(n) ? n : (e) => String(e[n] ?? "");
  return t.map(o).filter(Boolean).join(r);
}, h = (t, n, r) => {
  if (!t) return "";
  const o = s(n) ? n : (u) => String(u[n] ?? ""), e = t.map(o).filter(Boolean);
  if (e.length <= 1) return e.join(", ");
  const i = [...e], c = i.pop();
  return `${i.join(", ")} ${r} ${c}`;
};
function p(t, n) {
  return [...t.filter((r) => n.indexOf(r) === -1), ...n.filter((r) => t.indexOf(r) === -1)];
}
function g(t) {
  const n = Math.floor(Math.random() * t.length);
  return t[n];
}
function m(t, n) {
  const r = {}, o = [];
  for (const e of t) {
    const i = e[n];
    r[i] || (r[i] = !0, o.push(e));
  }
  return o;
}
function j(t, n) {
  const r = [];
  for (let o = 0; o < t; o++) r.push(n(o));
  return r;
}
export {
  l as arrayToMap,
  a as containsAll,
  A as containsAny,
  p as difference,
  g as getRandomItem,
  d as joinOn,
  h as joinWithAnd,
  j as loopIntoArray,
  m as uniqBy
};
